import instance from '../index'

//获取歌单详情页数据
export  function getMusicListItem(id){
 return instance({
    method: 'get',
    url: `playlist/detail?id=${id}`,
  })
}
//获取歌单所有歌曲
export  function getSongList(arr){
  return instance({
     method: 'get',
     url: '/song/detail',
     params:{
      ids:arr
     }
   })
 }

 //获取歌词
 export  function getMusicLyric(id){
  return instance({
     method: 'get',
     url: `/lyric?id=${id}`,
   })
 }
 //获取MVxinxi
 export  function getMv(id){
  return instance({
     method: 'get',
     url: `/mv/detail?mvid=${id}`,
   })
 }
 //获取mv播放地址
 export  function getMvUrl(id){
  return instance({
     method: 'get',
     url: `/mv/url?id=${id}`,
   })
 }

 //获取mv评论
 export  function getMvComment(id){
  return instance({
     method: 'get',
     url: `/comment/mv?id=${id}`,
   })
 }
 //获取相似mv
 export  function getLikeMv(id){
  return instance({
     method: 'get',
     url: `/simi/mv?mvid=${id}`,
   })
 }
 //获取歌曲评论
 export  function getSongComment(id){
  return instance({
     method: 'get',
     url: `/comment/music?id=${id}&limit=38`,
     
   })
 }
